'use client'
import { useTranslator } from '@/hooks'
import { FC } from 'react'
import styled from 'styled-components'
import type { TypeValidCatalogSlugs } from '@/app/[lang]/(public)/catalog/detail/[slug]/page'
import { ButtonCta } from './layout/AsidePreFooter'
// import { MODALS } from '@/context'
import { mq, presetsFluid, rgbAlpha, vw } from '@/styles'
import { CONTACT_FORM_EXTERNAL_URL } from '@/utils'

type Props = {
  slug: TypeValidCatalogSlugs
}

export const SectionCatalogDetailInfo:FC<Props> = ({ slug }) => {
  const { t } = useTranslator()
  // const { updatePayload } = useModal(MODALS.AUTH_CONTACT)
  const onClick = () => {
    // updatePayload({ open: true })
		window.location.href = CONTACT_FORM_EXTERNAL_URL
  }

  return (
    <Section>
      <div className='half'>
        <div className='media-wrapper'>
          <video autoPlay muted loop playsInline preload='auto'>
            <source src={`/media/catalog/${slug}/1.mp4`} type='video/mp4' />
          </video>
        </div>
      </div>
      <hgroup>
        <h2>{t(`project.catalog_detail.${slug}.section_cta.title`)}</h2>
        <div className='md' dangerouslySetInnerHTML={{ __html: t(`project.catalog_detail.${slug}.section_cta.description`) }} />
        <p>{t(`project.catalog_detail.${slug}.section_cta.text`)}</p>
        <ButtonCta type='button' onClick={onClick}>
          {t(`project.catalog_detail.${slug}.section_cta.cta`)}
        </ButtonCta>
      </hgroup>
    </Section>
  )
}

const Section = styled.section`
  align-items: flex-start;
  border-top: 1px solid ${rgbAlpha('--color-text', .2)};
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  width: var(--viewport-width);
  width: var(--viewport-width--dynamic);

  ${mq.greaterThan('tablet')} {
    flex-direction: row;
  }

  hgroup {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: ${vw(20, 'mobile')};
    justify-content: flex-start;
    order: 2;

    ${mq.greaterThan('nexus7')} {
      gap: ${vw(20, 'tablet')};
    }

    ${mq.greaterThan('tablet')} {
      flex-direction: row;
      flex-wrap: wrap;
      gap: ${vw(20, 'desktop')};
      order: initial;
    }

    ${mq.greaterThan('desktop')} {
      gap: 20px;
    }
  }

  hgroup,
  .half {
    padding: ${vw(20, 'mobile')} ${vw(10, 'mobile')};
    width: 100%;

    ${mq.greaterThan('nexus7')} {
      padding: ${vw(20, 'tablet')} ${vw(10, 'tablet')};
    }

    ${mq.greaterThan('tablet')} {
      height: 100%;
      height: -webkit-fill-available;
      padding: ${vw(30, 'desktop')};
      width: 50vw;
      width: 50dvw;
    }

    ${mq.greaterThan('desktop-xs')} {
      width: var(--viewport-width-half);
      width: var(--viewport-width-half--dynamic);
    }

    ${mq.greaterThan('desktop')} {
      padding: 30px;
    }
  }

  hgroup {
    > p {
      ${presetsFluid.font17_18()}
      max-width: 50%;

			${mq.greaterThan('desktop')} {
				${presetsFluid.font18_rel()}
			}
    }
  }

  .half {
    ${mq.greaterThan('tablet')} {
      align-items: flex-end;
      border-right: 1px solid ${rgbAlpha('--color-text', .2)};
      display: flex;
    }
  }

  h2 {
    ${presetsFluid.font18()}
    margin-bottom: 20px;
    opacity: .4;
    text-align: left;
    width: 100%;

		${mq.greaterThan('desktop')} {
			${presetsFluid.font18_rel()}
		}
  }

  button {
    margin-left: auto;
  }

  .md {
    ${presetsFluid.font20_25()}
    margin-bottom: 90px;
    width: 100%;

		${mq.greaterThan('desktop')} {
			${presetsFluid.font25_rel()}
		}
  }

  .media-wrapper {
    height: ${vw(229, 'mobile')};
    overflow: hidden;
    width: ${vw(370, 'mobile')};

    ${mq.greaterThan('nexus7')} {
      height: ${vw(229, 'tablet')};
      width: ${vw(370, 'tablet')};
    }

    ${mq.greaterThan('tablet')} {
      height: ${vw(349, 'desktop')};
      margin-top: auto;
      width: ${vw(545, 'desktop')};
    }

    ${mq.greaterThan('desktop')} {
      height: 349px;
      width: 545px;
    }

    video {
      height: 100%;
      object-fit: cover;
      width: 100%;
    }
  }
`
